module.exports = __webpack_public_path__ + "img/niu.d2d57893.gif";